/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import analytics from "analytics/analytics";
import baustein from "baustein";
import browser from "utils/browser";
import url from "utils/url";
import userProfiler from "modules/userprofiler";

/**
 * This module 'signup-button' displays the signup
 * overlay when clicking "signup" in the header
 *
 * @constructor
 * @alias module:components/signup-button
 * @extends module:baustein
 */
export default baustein.register("signup-button", {
    defaultOptions: {
        joinUrl: "/",
        reason: "header"
    },

    setupEvents(add) {
        add("click", ".signup-button", this.onClick);
    },

    onClick(event) {
        analytics.event("signup", "click", this.options.reason);

        if (browser.getViewport() === browser.VIEWPORTS.MOBILE) {
            userProfiler.setJoinOverlayShown();
            return;
        }

        event.preventDefault();
        // parse join url and get query params
        const parsedUrl = url.parse(this.options.joinUrl);
        const queryParams = parsedUrl.searchParams.toJSON();

        const options = {
            path: parsedUrl.path,
            pageType: "signup_form",
            pageSubType: "signup_header",
            formType: "signup",
            queryParams: queryParams
        };

        // send it up to the lyst-app to open
        this.emit("triggerSignup", options);
    }
});

